<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-福利金管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="getAppinfo('welfare_text')+'明细'" name="first"></el-tab-pane>
      <el-tab-pane :label="getAppinfo('welfare_text')+'设置'" name="second"></el-tab-pane>
    </el-tabs>
    <!--福利金明细-->
    <Log v-if="activeName == 'first'"></Log>
    <!--福利金设置-->
    <Setting v-if="activeName == 'second'"></Setting>

    
  </div>
</template>
<script>
import Log from './index/index';
import Setting from './setting/getSetting';
export default {
  components: {
    Setting,
    Log
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  methods: {}
};
</script>

<style>

</style>





// WEBPACK FOOTER //
// src/views/user/welfare/index.vue